module.exports = __webpack_public_path__ + "img/dotBar.28cc2125.svg";